import { ColumnsButton } from '../../components/admin/columns-button';
import { ListExportButton } from '../../components/custom/ListExportButton';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';

export const PostToolbarActions = () => {
  return (
    <MoonstarListActions hideCreate>
      <ColumnsButton />
      <ListExportButton maxResults={200} />
    </MoonstarListActions>
  );
};
